// extracted by mini-css-extract-plugin
module.exports = {"spacing":"ReferralTemplate_spacing__E9vUq"};